/**
 * The Firebase id_token of a signed-in user, or null. users/create checks with it that the caller
 * really owns the uid and the address it sends.
 */
export async function firebaseIdToken(authUser) {
  try {
    return authUser && typeof authUser.getIdToken === "function" ? await authUser.getIdToken() : null;
  } catch (e) {
    return null;
  }
}
